import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { TodayDataEntity } from 'src/app/models/data-entities/today-data-entity';
import { UntypedFormBuilder, NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-today-data-entity-input',
    templateUrl: './today-data-entity-input.component.html',
    styleUrls: ['./today-data-entity-input.component.css'],
    standalone: false
})
export class TodayDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: TodayDataEntity;
   templateForPermitForm: boolean = false
  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    ref: ChangeDetectorRef,
    private _dataSvc: DataService,
    private _fb: UntypedFormBuilder,
    context : WorkflowContextService
  ) {
    super(layoutService, componentFactoryResolver, ref, context);
      //added by juber 31-12-2025

        layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
     //end by juber 31-12-2025

  }

  todaysDate: Date;

  ngOnInit() {
    this.todaysDate = this.entity.value;
  }
}
